import { Skeleton } from '@material-ui/lab';
import './DetailTicketListSkeleton.css';

export default function DetailTicketListSkeleton() {
    return (
        <div className='skeleton-ticket-item'>
            <Skeleton className='skeleton-ticket-head' animation="wave" variant="rect" width={150} height={18}/>
            <div className='skeleton-ticket-info-wrap'>
                <div className='skeleton-prj-icon'>
                    <Skeleton animation="wave" variant="rect" width={60} height={55} />
                </div>
                {/* <div className='skeleton-ticket-info'> */}
                    <Skeleton className='skeleton-ticket-title' animation="wave" variant="rect" width='100%' height={55} />
                    {/* <Skeleton animation="wave" variant="rect" width='100%' height={22} /> */}
                {/* </div> */}
                <div className='skeleton-ticket-status'>
                    <Skeleton animation="wave" variant="rect" width={60} height={55} />
                </div>
            </div>

            <Skeleton className='skeleton-ticket-head' animation="wave" variant="rect" height={23}/>
            
        </div>
    );
}
